<section class="modal-content modal-content-right">
  <button cjButton aria-label="Close" class="modal-close" tabIndex="-1" (click)="onClose()">
    <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
  </button>

  <form #recurringForm="ngForm">
    <div class="summary-content p-6 flex flex-col gap-5">
      <div class="flex flex-col gap-5">
        <h5>Recurring Payment Details</h5>

        <div class="summary-container p-7">
          <div *ngIf="isLoading" class="flex items-center justify-center" style="height: 500px">
            <img src="./assets/images/preloader.gif" />
          </div>

          <div *ngIf="!isLoading" class="flex flex-col gap-6">
            <section *ngIf="invoiceNumber">
              <label>Recurring Invoice Number</label>
              <div class="flex items-center gap-2.5">
                <strong class="invoice-summary-number">
                  {{ invoiceNumber }}
                </strong>
                <span class="tag-pill tag-{{ getStatus(true) }}">
                  {{ getStatus() }}
                </span>
              </div>
            </section>

            <section>
              <label>Recurring Details</label>
              <div class="details-container flex flex-col gap-1.5">
                <div class="grid grid-cols-12 font-medium">
                  <span class="col-span-4 flex">
                    <cj-icon
                      class="icon-small text-gray-60 mr-2.5"
                      style="margin-top: 3px;"
                      icon="calendar"
                      pack="font-awesome-solid"
                    ></cj-icon>
                    Start Date
                  </span>
                  <span class="subtitle col-span-8">
                    {{ invoiceNumber ? (recurring.startDate | date: "MM/dd/yyyy") : '-' }}
                  </span>
                </div>

                <div class="grid grid-cols-12 font-medium">
                  <span class="col-span-4 flex">
                    <cj-icon
                      class="icon-small text-gray-60 mr-2.5"
                      style="margin-top: 3px;"
                      icon="calendar-minus"
                      pack="font-awesome-solid"
                    ></cj-icon>
                    End Date
                  </span>
                  <span class="subtitle col-span-8">
                    {{ recurring.endDate ? (recurring.endDate | date: "MM/dd/yyyy") : '-' }}
                  </span>
                </div>

                <div class="grid grid-cols-12 font-medium">
                  <span class="col-span-4 flex">
                    <cj-icon
                      class="icon-small text-gray-60 mr-2.5"
                      style="margin-top: 3px;"
                      icon="calendar-week"
                      pack="font-awesome-solid"
                    ></cj-icon>
                    Schedule
                  </span>
                  <span class="subtitle col-span-8">
                    {{ recurring.frequency ? getFrequency(recurring.frequency) : '-' }}</span>
                </div>

                <div class="grid grid-cols-12 font-medium">
                  <span class="col-span-4 flex">
                    <cj-icon
                      class="icon-small text-gray-60 mr-2.5"
                      style="margin-top: 3px;"
                      icon="calendar-day"
                      pack="font-awesome-solid"
                    ></cj-icon>
                    Next Recurrence Date
                  </span>
                  <span class="subtitle col-span-8">
                    {{ recurring.nextRecurrenceDate | date: "MM/dd/yyyy" }}
                  </span>
                </div>

                <div class="grid grid-cols-12 font-medium">
                  <span class="col-span-4 flex">
                    <cj-icon
                      class="icon-small text-gray-60 mr-2.5"
                      style="margin-top: 3px; width: 12px;"
                      icon="dollar-sign"
                      pack="font-awesome-solid"
                    ></cj-icon>
                    Amount
                  </span>
                  <span class="subtitle col-span-8">
                    {{ recurring.amount | currency }}
                  </span>
                </div>
              </div>
            </section>

            <section>
              <label>Customer Details</label>
              <div class="details-container flex flex-col gap-1">
                <h5>
                  {{ recurring.customerName }}
                </h5>
                <div *ngIf="getDefaultCustomerAddress()">
                  <cj-icon
                    class="icon-small text-gray-60 mr-2"
                    icon="map-marker-alt"
                    pack="font-awesome-solid"
                  ></cj-icon>
                  <span class="subtitle">{{
                    getDefaultCustomerAddress()
                  }}</span>
                </div>
                <div *ngIf="customer.EmailAddress">
                  <cj-icon
                    class="icon-small text-gray-60 mr-2"
                    icon="envelope"
                    pack="font-awesome-solid"
                  ></cj-icon>
                  <span class="subtitle">{{ customer.EmailAddress }}</span>
                </div>
                <div *ngIf="getDefaultPhone()">
                  <cj-icon
                    class="icon-small text-gray-60 mr-2"
                    icon="phone"
                    pack="font-awesome-solid"
                  ></cj-icon>
                  <span class="subtitle">{{ getDefaultPhone() }}</span>
                </div>
              </div>
            </section>

            <section>
              <label>Payment Schedule</label>
              <div class="details-container flex flex-column">
                <app-payment-schedule
                  [parent]="this"
                  ngModelGroup="child"
                ></app-payment-schedule>
              </div>
            </section>

            <section>
              <label>Card on File</label>
              <div class="details-container flex flex-col gap-1">
                <div *ngIf="customerCards.length">
                  <cj-radio-group
                    class="card-list"
                    name="CustomerCard"
                    [ngModel]="selectedCard?.Id"
                    (ngModelChange)="onSelectCard($event)"
                  >
                    <cj-radio
                      *ngFor="let card of customerCards; let i = index"
                      class="card-item" 
                      [class.selected]="selectedCard?.Id === card.Id"
                      [value]="card.Id"
                    >
                      <cj-icon class="text-cyan-60 mr-6" icon="cc-{{ card.CardBrand }}" pack="font-awesome-brands"></cj-icon>
                      {{ card.CardBrand | uppercase }} ****{{ card.CardLast4Digits }}
                    </cj-radio>
                  </cj-radio-group>
                </div>
              </div>
            </section>

            <section>
              <label>Invoice List</label>
              <div class="details-container flex flex-column gap-1 p-0">
                <ag-grid-angular
                  style="width: 100%"
                  class="ag-theme-material ag-theme-invoice-list"
                  [rowData]="invoices"
                  [pagination]="true"
                  [paginationPageSize]="5"
                  [columnDefs]="gridColumns"
                  [defaultColDef]="{ suppressMovable: true }"
                  (gridReady)="onGridReady($event)"
                >
                </ag-grid-angular>
              </div>
            </section>
          </div>
        </div>

        <div class="summary-history pl-2.5 flex align-center justify-between" *ngIf="recurring?.data && !isLoading">
          <div>
            <small>
              Created on
              <strong>{{
                recurring.data?.createdDate | date: "MM/dd/yyyy, hh:mm:ss a"
              }}</strong>
            </small>
          </div>
          <div *ngIf="recurring.data?.updatedDate && recurring.data?.updatedDate !== 'null'">
            <small>
              Last update
              <strong>{{
                recurring.data?.updatedDate | date: "MM/dd/yyyy, hh:mm:ss a"
              }}</strong>
            </small>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end gap-2.5" *ngIf="!isLoading">
        <button
          *ngIf="status !== 'Cancelled'"
          cjButton
          outline
          size="large"
          [disabled]="isSaving"
          (click)="onSaveChanges()"
        >
          <cj-icon icon="pencil-alt" pack="font-awesome-solid"></cj-icon>
          Save Changes
        </button>

        <ng-container *ngIf="canAccessMore()">
          <button
            cjButton
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            size="large"
            [disabled]="isSaving"
          >
            <cj-icon icon="ellipsis-v" pack="font-awesome-solid"></cj-icon>
            More Action
          </button>
          <div class="multiple-list dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a
              *ngIf="canCancel()"
              class="dropdown-item"
              (click)="onCancelRecurringPayment()"
            >Cancel</a>
            <a
              *ngIf="canPause()"
              class="dropdown-item"
              (click)="onPauseResumeRecurringPayment('pause')"
            >Pause</a>
            <a
              *ngIf="canResume()"
              class="dropdown-item"
              (click)="onPauseResumeRecurringPayment('resume')"
            >Resume</a>
            <!-- <a
              *ngIf="canSuspend()"
              class="dropdown-item"
              (click)="onSuspendRecurringPayment()"
            >Suspend</a>
            <a
              *ngIf="status === 'Suspended'"
              class="dropdown-item"
              (click)="onViewSuspendDetails()"
            >View Suspension Details</a> -->
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</section>
